/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Closedeals2Inputs */

const en_coinvestments_tracking_closedeals2 = /** @type {(inputs: Coinvestments_Tracking_Closedeals2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Opportunities`)
};

/**
* | output |
* | --- |
* | "Close Opportunities" |
*
* @param {Coinvestments_Tracking_Closedeals2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_closedeals2 = /** @type {((inputs?: Coinvestments_Tracking_Closedeals2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Closedeals2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_closedeals2(inputs)
});
export { coinvestments_tracking_closedeals2 as "coInvestments_tracking_closeDeals" }